import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export var fullName = function fullName(obj) {
  return obj ? [obj.first_name, obj.middle_name, obj.last_name].filter(function (name) {
    return !!name;
  }).join(' ') : '';
};